export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'LEFT_TOOLBAR_EXPAND':
      return {
        expanded: true,
        dialog: payload.dialog,
        editable: payload.editable ? payload.editable : null,
        mapObj: payload.mapObj ? payload.mapObj : null,
        // A tab to open the dialog on, e.g. Map Tools' 'addStand' from the Weather Center (WEB-7144).
        tab: payload.tab ? payload.tab : null
      }
    case 'LEFT_TOOLBAR_COLLAPSE':
      return {
        expanded: false,
        dialog: null,
        editable: null,
        mapObj: null
      }
    case 'LOGOUT':
      return {
        expanded: false,
        dialog: null,
        editable: null
      }
    default:
      return state
  }
}